import React, { useEffect, useState, useCallback, useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import SportsBasketballRoundedIcon from "@mui/icons-material/SportsBasketballRounded";
import CasinoRoundedIcon from "@mui/icons-material/CasinoRounded";
import StadiumIcon from '@mui/icons-material/Stadium';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import EmailIcon from '@mui/icons-material/Email';
import Badge from "@mui/material/Badge";
import {
  AssessmentOutlined,
  BlockRounded,
  ClassRounded,
  ContactPageRounded,
  LockRounded,
  MarkUnreadChatAlt,
  PeopleRounded,
} from "@mui/icons-material";
import axios from "axios";
import api_url from "../constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReqCallContext, ReqCallProvider } from "../context/ReqCallContext";
import "../style/single.css";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SettingsIcon from '@mui/icons-material/Settings';
import GroupsIcon from "@mui/icons-material/Groups";
import BlockIcon from "@mui/icons-material/Block";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ReceiveCash from "./ReceiveCash";
import PayCash from "./PayCash";
import Ledger from "./Ledger";
import ChangePassword from "./ChangePassword";
import CreateMessage from "./CreateMessage";
import CashLedger from "./CashLedger";
import MatchLedger from "./MatchLedger";
import BlockedUsers from "./BlockedUsers";
const Spinner = React.lazy(() => import("./Spinner"));
const Dashboard = React.lazy(() => import("./Dashboard"));
const SideBarItem = React.lazy(() => import("./SideBarItem"));
const UserDashboard = React.lazy(() => import("./UserDashboard"));
const Matches = React.lazy(() => import("./Matches"));
const LiveCasino = React.lazy(() => import("./LiveCasino"));
const CasinoResults = React.lazy(() => import("./CasinoResults"));
const BlockMarket = React.lazy(() => import("./BlockMarket"));
const ManageClient = React.lazy(() => import("./ManageClient"));
const ManagePassword = React.lazy(() => import("./ManagePassword"));
const ManageLedger = React.lazy(() => import("./ManageLedger"));
const CreateClients = React.lazy(() => import("./CreateClients"));
const Agent = React.lazy(() => import("./Agent"));
const Stockist = React.lazy(() => import("./Stockist"));
const CreateStockist = React.lazy(() => import("./CreateStockist"));
const CreateAgent = React.lazy(() => import("./CreateAgent"));
const CreateSuperCompany = React.lazy(() => import("./CreateSuperCompany"));
const CreateSuperStockist = React.lazy(() => import("./CreateSuperStockist"));
const CreateMasterAdmin = React.lazy(() => import("./CreateMasterAdmin"));
const CreateAdminAdmin = React.lazy(() => import("./CreateAdminAdmin"));
const CreateBookie = React.lazy(() => import("./CreateBookie"));
const MasterAdmin = React.lazy(() => import("./MasterAdmin"));
const Bookie = React.lazy(() => import("./Bookie"));
const SuperAdmin = React.lazy(() => import("./SuperAdmin"));
const CreateSuperAdmin = React.lazy(() => import("./CreateSuperAdmin"));
const SuperCompany = React.lazy(() => import("./SuperCompany"));
const SuperStockist = React.lazy(() => import("./SuperStockist"));
const CommisionsAndLimits = React.lazy(() => import("./CommisionsAndLimits"));
const MatchDetails = React.lazy(() => import("./MatchDetails"));
const Manager = React.lazy(() => import("./Manager"));
const CreateManager = React.lazy(() => import("./CreateManager"));
const SessionBetSlip = React.lazy(() => import("./SessionBetSlip"));
const EditDetails = React.lazy(() => import("./EditDetails"));
const LiveReport = React.lazy(() => import("./LiveReport"));
const CoinHistory = React.lazy(() => import("./CoinHistory"));
const BetSlips = React.lazy(() => import("./BetSlips"));
const CollectionReport = React.lazy(() => import("./CollectionReport"));
const Ledgers = React.lazy(() => import("./Ledgers"));
const ProfitAndLoss = React.lazy(() => import("./ProfitAndLoss"));
const ClientReport = React.lazy(() => import("./ClientReport"));
const CompanyReport = React.lazy(() => import("./CompanyReport"));
const SessionEarningReport = React.lazy(() => import("./SessionEarningReport"));
const UserBets = React.lazy(() => import("./UserBets"));
const DirectAgent = React.lazy(() => import("./DirectAgent"));
const AllPlayers = React.lazy(() => import("./AllPlayers"));
const Inbox = React.lazy(() => import("./Inbox"));
const UpdateMatchDetails = React.lazy(()=> import("./UpdateMatchDetails"))
function Main(props) {
  const [open, setOpen] = useState(false);
  const [clientOpen, setClientOpen] = useState(false);
  const [hasNewMessage, setHasNewMessage] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);
  const [ledgerOpen, setLedgerOpen] = useState(false);
  const [matchesOpen, setMatchesOpen] = useState(false);
  const [activeMatchTab, setActiveMatchTab] = useState('live'); // 'live', 'upcoming', 'completed'
  const [dataLoading, setDataLoading] = useState(true);
  const [message, setMessage] = useState("");
  const { userContext, setUserContext } = props;
  const [reqCall, setReqCall] = useContext(ReqCallContext);
  const [showLoginSuccess, setShowLoginSuccess] = useState(false);

  const logoutHandler = async () => {
    try {
      await axios.get(api_url + "/auth/adminLogout", {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userContext.token}`,
        },
      });

      setUserContext((oldValues) => {
        return { ...oldValues, details: undefined, token: null };
      });
      document.cookie =
        "jsession=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

      // Set a timestamp in local storage
      window.localStorage.setItem("logout", Date.now());
      window.location.reload();
    } catch (error) {
      // Handle errors
      console.error("Error during logout:", error);
    }
  };

  const fetchUserDetails = useCallback(async () => {
    try {
      const response = await axios.get(`${api_url}/auth/me`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userContext.token}`,
        },
        withCredentials: true,
        validateStatus: function (status) {
          return status >= 200; // Treat any status code in the 2xx range as a success
        },
      });

      if (response.status === 200) {
        const data = response.data;
        setUserContext((oldValues) => {
          return { ...oldValues, details: data };
        });
      } else {
        if (response.status === 401) {
          setUserContext((oldValues) => {
            return { ...oldValues, details: null, token: null };
          });
        }
        // Handle non-200 status codes here if needed
        // For example, you can show an error message to the user
      }
    } catch (error) {
      // Handle network or other errors here
      console.error("An error occurred:", error);
      setDataLoading(false);
      return;
    } finally {
      setDataLoading(false);
    }
  }, [setUserContext, userContext.token]);
  const fetchMessage = async () => {
    setReqCall(reqCall + 1);
    const response = await axios.get(`${api_url}/api/getAdminMessage`, {
      headers: {
        Authorization: `Bearer ${userContext.token}`,
      },
    });
    const msg = response.data;

    setMessage(msg);
    if (msg && msg.message) {
      const lastReadTime = localStorage.getItem("adminLastReadMessageTime");

      if (msg.created_on !== lastReadTime) {
        setHasNewMessage(true);
      } else {
        setHasNewMessage(false);
      }
    }
  };
  useEffect(() => {
    // Fetch only when user details are not present
    fetchUserDetails();
  }, [userContext.token]);
  useEffect(() => {
    fetchMessage();
  }, []);

  // Check for login success flag
  useEffect(() => {
    const showSuccess = localStorage.getItem("showLoginSuccess");
    if (showSuccess === "true") {
      setShowLoginSuccess(true);
      // Remove the flag so it doesn't show again
      localStorage.removeItem("showLoginSuccess");
      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setShowLoginSuccess(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);
  // Get current location from react-router
  const location = useLocation();

  // Update active tab when URL changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('status');
    if (status && ['live', 'upcoming', 'completed'].includes(status)) {
      setActiveMatchTab(status);
    }
  }, [location]);
  const level = userContext.details ? userContext.details.level : null;
  const isAgent = level > 0 && level <= 8;
  const handleClick = () => {
    setOpen(!open);
  };

  const handleClientClick = () => {
    setClientOpen(!clientOpen);
  };

  const handleLedgerClick = () => {
    setLedgerOpen(!ledgerOpen);
    if (!ledgerOpen) {
      setClientOpen(false);
      setOpen(false);
    }
  };

  const handleSettingClick = () => {
    setSettingOpen(!settingOpen);
  };

  // Alias for handleLedgerClick to match the onClick handler
  const handleLedger = handleLedgerClick;

  // Alias for handleClientClick to match the onClick handler
  const handleClients = handleClientClick;

  const handleSettings = handleSettingClick;

  // Handle matches dropdown toggle
  const handleMatchesClick = () => {
    setMatchesOpen(!matchesOpen);
    if (!matchesOpen) {
      setClientOpen(false);
      setOpen(false);
      setLedgerOpen(false);
    }
  };

  // Get navigate function from react-router-dom
  const navigate = useNavigate();

  // Handle match tab change
  const handleMatchTabChange = (tab) => {
    setActiveMatchTab(tab);
    setMatchesOpen(false);
    // Update the URL and close the mobile sidebar
    navigate(`/matches?status=${tab}`);
    close(); // Close the mobile sidebar after selection
  };
  const close = () => {
    if (window.innerWidth < 992) {
      const mainSite = document.getElementById("mainsite");
      mainSite.classList.remove("active");
    }
  };
  const toggleNavBar = () => {
    const mainSite = document.getElementById("mainsite");
    if (mainSite.classList.contains("active")) {
      mainSite.classList.remove("active");
    } else {
      mainSite.classList.add("active");
    }
  };

  if (dataLoading) {
    return <Spinner color="#222" style={{ marginTop: 20 }} />;
  }
  return (
    <div>
      <section className="mainsite" id="mainsite">
        <nav className="sidenav">
          <div className="menu">
            <div className="profile-side">
              <h2 style={{ textAlign: 'center' }}>BSF5050</h2>
              {/* {userContext.details.username}({userContext.details.name}) */}
            </div>

            <ul className="menu-list">
              <SideBarItem
                visible={isAgent}
                title="Dashboard"
                Icon={GridViewRoundedIcon}
                path="/"
                onClick={() => close()}
              />

              {/* Matches Dropdown */}
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "#1b1c1c",
                  color: "#fff",
                  padding: 0,
                }}
                component="nav"
              >
                <SideBarItem
                  visible={isAgent}
                  title="Matches"
                  Icon={SportsBasketballRoundedIcon}
                  style={{
                    backgroundColor: matchesOpen ? "#365383;" : "#1b1c1c",
                  }}
                  onClick={handleMatchesClick}
                  LeftIcon={matchesOpen ? ExpandLess : ExpandMore}
                />
                <Collapse in={matchesOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <SideBarItem
                      title="Active Matches"
                      path="/matches?status=live"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: activeMatchTab === 'live' ? 'rgba(0, 150, 0, 0.3)' : 'rgba(0,0,0,0.4)',
                      }}
                      onClick={() => handleMatchTabChange('live')}
                      Icon={SportsBasketballRoundedIcon}
                      visible={isAgent}
                    />
                    <SideBarItem
                      title="Schedule Matches"
                      path="/matches?status=upcoming"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: activeMatchTab === 'upcoming' ? 'rgba(0, 100, 200, 0.3)' : 'rgba(0,0,0,0.4)',
                      }}
                      onClick={() => handleMatchTabChange('upcoming')}
                      Icon={SportsBasketballRoundedIcon}
                      visible={isAgent}
                    />
                    <SideBarItem
                      title="Completed Matches"
                      path="/matches?status=completed"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: activeMatchTab === 'completed' ? 'rgba(150, 150, 150, 0.3)' : 'rgba(0,0,0,0.4)',
                      }}
                      onClick={() => handleMatchTabChange('completed')}
                      Icon={SportsBasketballRoundedIcon}
                      visible={isAgent}
                    />
                  </List>
                </Collapse>
              </List>
              {isAgent && (
                <List
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                    bgcolor: "#1b1c1c",
                    color: "#fff",
                    padding: 0,
                  }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  <SideBarItem
                    visible={isAgent && level !== 7}
                    title="Manage"
                    Icon={GroupsIcon}
                    style={{
                      backgroundColor: open ? "#365383" : "#1b1c1c",
                    }}
                    onClick={handleClick}
                    LeftIcon={open ? ExpandLess : ExpandMore}
                  />
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {/* <SideBarItem
                        path="/adminAdmin"
                        title="Admin Admin"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                        onClick={() => close()}
                        Icon={GroupsIcon}
                        visible={level === 0}
                      /> */}
                      <SideBarItem
                        path="/superAdmin"
                        title="Super Admin"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                        onClick={() => close()}
                        Icon={GroupsIcon}
                        visible={level === 1}
                      />

                      <SideBarItem
                        path="/admin"
                        title="Admin"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                        onClick={() => close()}
                        Icon={GroupsIcon}
                        visible={level <= 2}
                      />
                      <SideBarItem
                        path="/superCompany"
                        title="Super Company"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                        onClick={() => close()}
                        Icon={GroupsIcon}
                        visible={level <= 3}
                      />
                      <SideBarItem
                        path="/superStockist"
                        title="Super Stockist"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                        onClick={() => close()}
                        Icon={GroupsIcon}
                        visible={level <= 4}
                      />
                      <SideBarItem
                        path="/stockist"
                        title="Stockist"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                        onClick={() => close()}
                        Icon={GroupsIcon}
                        visible={level <= 5}
                      />
                      <SideBarItem
                        path="/agent"
                        title="Agent"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                        onClick={() => close()}
                        Icon={GroupsIcon}
                        visible={level <= 6}
                      />
                      {/* Manager option removed from dropdown */}
                    </List>
                  </Collapse>
                </List>
              )}
              {/* Old Matches menu item removed - using dropdown instead */}
              <SideBarItem
                visible={isAgent}
                title="Live Casino"
                Icon={SportsBasketballRoundedIcon}
                path="/liveCasino"
                onClick={() => close()}
              />

              <SideBarItem
                visible={isAgent}
                path="/casinoResult"
                title="Check Casino Results"
                Icon={SearchRoundedIcon}
                onClick={() => close()}
              />
              <SideBarItem
                visible={isAgent}
                title="Block Market"
                Icon={SportsBasketballRoundedIcon}
                onClick={() => close()}
                path="/blockMarket"
              />

              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "#1b1c1c",
                  color: "#fff",
                  padding: 0,
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <SideBarItem
                  noBorder={clientOpen}
                  visible={isAgent}
                  title="Manage Clients"
                  Icon={GroupsIcon}
                  style={{
                    backgroundColor: clientOpen ? "#365383" : "#1b1c1c",
                  }}
                  onClick={handleClients}
                  LeftIcon={clientOpen ? ExpandLess : ExpandMore}
                />
                <Collapse in={clientOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {userContext.details.level !== 1 && (
                      <SideBarItem
                        visible={isAgent}
                        title="My Clients"
                        Icon={PeopleRounded}
                        onClick={() => close()}
                        path="/manageClient"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                      />
                    )}

                    <SideBarItem
                      visible={isAgent}
                      title="Blocked Users"
                      Icon={GroupsIcon}
                      onClick={() => close()}
                      path="/BlockedUsers"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: "rgba(0,0,0,0.4)",
                      }}
                    />
                    <SideBarItem
                      visible={isAgent}
                      title="Commision & Limits"
                      Icon={CurrencyRupeeIcon}
                      onClick={() => close()}
                      path="/commisionAndLimits"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: "rgba(0,0,0,0.4)",
                      }}
                    />
                  </List>
                </Collapse>
              </List>
              <SideBarItem
                visible={isAgent}
                title="Manage Password"
                onClick={() => close()}
                Icon={LockRounded}
                path="/managePassword"
              />
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "#1b1c1c",
                  color: "#fff",
                  padding: 0,
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <SideBarItem
                  visible={isAgent}
                  title="Manage Ledger"
                  Icon={ClassRounded}
                  style={{
                    backgroundColor: ledgerOpen ? "#365383" : "#1b1c1c",
                  }}
                  noBorder={ledgerOpen}
                  onClick={handleLedger}
                  LeftIcon={ledgerOpen ? ExpandLess : ExpandMore}
                />
                <Collapse in={ledgerOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <SideBarItem
                      visible={isAgent}
                      title="Collection Report"
                      Icon={ClassRounded}
                      onClick={() => close()}
                      path="/collectionReport"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: "rgba(0,0,0,0.4)",
                      }}
                    />
                    {level !== 1 && (
                      <SideBarItem
                        visible={isAgent}
                        title="Company Len-Den"
                        Icon={ClassRounded}
                        onClick={() => close()}
                        path="/ledgers"
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                      />
                    )}
                    {level !== 1 && (
                      <SideBarItem
                        visible={isAgent}
                        title="My Stmt."
                        Icon={AssessmentOutlined}
                        onClick={() => close()}
                        path={`/statementByUser/${userContext.details.username}`}
                        style={{
                          paddingLeft: 50,
                          backgroundColor: "rgba(0,0,0,0.4)",
                        }}
                      />
                    )}
                    <SideBarItem
                      visible={isAgent}
                      title="P & L"
                      Icon={CurrencyRupeeIcon}
                      onClick={() => close()}
                      path={`/profitAndLoss/${userContext.details.username}`}
                      style={{
                        paddingLeft: 50,
                        backgroundColor: "rgba(0,0,0,0.4)",
                      }}
                    />
                  </List>
                </Collapse>

                <SideBarItem
                  noBorder={settingOpen}
                  visible={level === 1}
                  title="BSF5050 Settings"
                  Icon={SettingsIcon}
                  style={{
                    backgroundColor: settingOpen ? "#365383" : "#1b1c1c",
                  }}
                  onClick={handleSettings}
                  LeftIcon={settingOpen ? ExpandLess : ExpandMore}
                />
                <Collapse in={settingOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <SideBarItem
                      visible={level === 1}
                      title="Message"
                      onClick={() => close()}
                      Icon={MarkUnreadChatAlt}
                      path="/createMessage"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: "rgba(0,0,0,0.4)",
                      }}
                    />
                    <SideBarItem
                      visible={level === 1}
                      title="Blocked Matches"
                      Icon={StadiumIcon}
                      onClick={() => close()}
                      path="/update-match-details"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: "rgba(0,0,0,0.4)",
                      }}
                    />
                    <SideBarItem
                      visible={level === 1}
                      title="Active Users"
                      Icon={GroupsIcon}
                      onClick={() => close()}
                      path="/allPlayers"
                      style={{
                        paddingLeft: 50,
                        backgroundColor: "rgba(0,0,0,0.4)",
                      }}
                    />
                  </List>
                </Collapse>

              </List>

            </ul>
          </div>
        </nav>
        <section className="mainpage" id="mainpage">
          <div className="burger" id="burger" onClick={() => toggleNavBar()}>
            <div className="burger-menu"></div>
          </div>
          <div className="container">
            <header>
              <div className="right-menu">
                <div style={{ display: "flex", paddingLeft: 10 }}>
                  <div>
                    <span className="c-logo">
                      <img src={require("../images/logo.png")} alt="logo" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex__align">
                <button
                  className="dashboard__btn email__btn"
                  style={{ padding: "0px 0px" }}
                  onClick={() => {
                    setHasNewMessage(false); // Clear badge on click
                    if (message && message.created_on) {
                      localStorage.setItem("adminLastReadMessageTime", message.created_on);
                    }
                    navigate('/inbox');
                  }}
                  title="Messages"
                >
                  <Badge color="error" variant="dot" invisible={!hasNewMessage}
                    sx={{
                      "& .MuiBadge-badge": {
                        top: 8,    // Decrease this number to move it Higher (e.g., 5, 0, or -5)
                        right: 8,  // Decrease this number to move it Right
                      }
                    }}
                  >
                    <EmailIcon fontSize="large" />
                  </Badge>
                </button>
                <button
                  className="dashboard__btn logout__btn"
                  style={{ padding: "0px 10px" }}
                  onClick={() => {
                    logoutHandler();
                  }}
                >
                  <svg fill="#000000" viewBox="0 0 32 32" version="1.1"

                    xmlns="http://www.w3.org/2000/svg"
                    height="40"
                    width="40"
                  >
                    <path d="M0 9.875v12.219c0 1.125 0.469 2.125 1.219 2.906 0.75 0.75 1.719 1.156 2.844 1.156h6.125v-2.531h-6.125c-0.844 0-1.5-0.688-1.5-1.531v-12.219c0-0.844 0.656-1.5 1.5-1.5h6.125v-2.563h-6.125c-1.125 0-2.094 0.438-2.844 1.188-0.75 0.781-1.219 1.75-1.219 2.875zM6.719 13.563v4.875c0 0.563 0.5 1.031 1.063 1.031h5.656v3.844c0 0.344 0.188 0.625 0.5 0.781 0.125 0.031 0.25 0.031 0.313 0.031 0.219 0 0.406-0.063 0.563-0.219l7.344-7.344c0.344-0.281 0.313-0.844 0-1.156l-7.344-7.313c-0.438-0.469-1.375-0.188-1.375 0.563v3.875h-5.656c-0.563 0-1.063 0.469-1.063 1.031z"></path>                  </svg>
                  <span className="svgBtn_text">Sign out</span>
                </button>
              </div>
            </header>
            {showLoginSuccess && (
              <div className="login-success-banner">
                <span className="login-success-text">Signed in successfully.</span>
                <button
                  className="login-success-close"
                  onClick={() => setShowLoginSuccess(false)}
                  aria-label="Close"
                >
                  ×
                </button>
              </div>
            )}
            <div className="marquee">
              <marquee>{message?.message ? message.message : "Welcome"}</marquee>
            </div>
            <div className="wrapper">
              <Routes>
                <Route
                  exact
                  path="/"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Dashboard
                        userData={userContext}
                        dataLoading={dataLoading}
                      />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/clientReport/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <ClientReport />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/matches"
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Matches userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/liveCasino"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <LiveCasino />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/ledgers"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Ledgers />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/profitAndLoss/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <ProfitAndLoss />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/receiveCash/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <ReceiveCash />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/payCash/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <PayCash />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/ledgerShow/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Ledger />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/matchLedger/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <MatchLedger />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/cashLedger/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CashLedger />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/casinoResults"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CasinoResults />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/superStockist"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <SuperStockist userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/stockist"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Stockist userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/manager"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Manager userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/matchDetails/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <MatchDetails />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/collectionReport/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CollectionReport />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/sessionEarningReport/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <SessionEarningReport userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/companyReport/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CompanyReport userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/collectionReport"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CollectionReport userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/betSlips/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <BetSlips />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/sessionBetSlips/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <SessionBetSlip userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/liveReport/:matchId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <LiveReport userData={userContext} />
                    </React.Suspense>
                  }
                />{" "}
                <Route
                  exact
                  path="/statementByUser/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CoinHistory userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/editDetails/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <EditDetails userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/superCompany"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <SuperCompany userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/Agent"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Agent userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createManager"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateManager userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/commisionAndLimits"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CommisionsAndLimits userData={userContext} />
                    </React.Suspense>
                  }
                />


                <Route
                  exact
                  path="/UserBets/:userId"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <UserBets userData={userContext} />
                    </React.Suspense>
                  }
                />



                {level !== 7 && (
                  <Route
                    exact
                    path="/DirectAgent/:userId"
                    index
                    element={
                      <React.Suspense
                        fallback={
                          <Spinner color="#222" style={{ marginTop: 20 }} />
                        }
                      >
                        <DirectAgent userData={userContext} />
                      </React.Suspense>
                    }
                  />


                )}


                {level === 1 && (
                  <Route
                    exact
                    path="/allPlayers"
                    index
                    element={
                      <React.Suspense
                        fallback={
                          <Spinner color="#222" style={{ marginTop: 20 }} />
                        }
                      >
                        <AllPlayers userData={userContext} />
                      </React.Suspense>
                    }
                  />


                )}
                {level === 1 && (
                  <Route
                    exact
                    path="/update-match-details"
                    index
                    element={
                      <React.Suspense
                        fallback={
                          <Spinner color="#222" style={{ marginTop: 20 }} />
                        }
                      >
                        <UpdateMatchDetails userData={userContext} />
                      </React.Suspense>
                    }
                  />


                )}


                <Route
                  exact
                  path="/inbox"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Inbox userData={userContext} />
                    </React.Suspense>
                  }
                />


                <Route
                  exact
                  path="/BlockedUsers"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <BlockedUsers userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/blockMarket"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <BlockMarket />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/manageClient"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <ManageClient userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/casinoResult"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CasinoResults />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/managePassword"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <ManagePassword />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/passwordEdit/:username"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <ChangePassword />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/manageLedger"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <ManageLedger />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createClient"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateClients userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createStockists"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateStockist userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createSuperStockist"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateSuperStockist userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/masterAdmin"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <MasterAdmin userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createMasterAdmin"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateMasterAdmin userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/admin"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Bookie userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createBookie"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateBookie userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createAdminAdmin"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateAdminAdmin userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/superAdmin"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <SuperAdmin userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createSuperAdmin"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateSuperAdmin userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createSuperCompany"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateSuperCompany
                        userData={userContext}
                        toast={toast}
                        ToastContainer={ToastContainer}
                      />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/createAgents"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <CreateAgent userData={userContext} />
                    </React.Suspense>
                  }
                />
                <Route
                  exact
                  path="/userDashboard/:username"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <UserDashboard />
                    </React.Suspense>
                  }
                />
                <Route
                  path="*"
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Dashboard
                        userData={userContext}
                        dataLoading={dataLoading}
                      />
                    </React.Suspense>
                  }
                />
                {level === 1 ? (
                  <Route
                    exact
                    path="/createMessage"
                    index
                    element={
                      <React.Suspense
                        fallback={
                          <Spinner color="#222" style={{ marginTop: 20 }} />
                        }
                      >
                        <CreateMessage />
                      </React.Suspense>
                    }
                  />
                ) : null}
              </Routes>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}

export default Main;
